import { makeHttpRequest } from "../../helpers/httpRequestHelpers";
import type { ApiPayload, RequestOptions } from "../../types";

export async function getRequest<T>(url: URL, options: RequestOptions = {}): Promise<T> {
	const { contentType, ref, fileName, skipSessionFailureOnAuthError, background } = options;
	return makeHttpRequest<T>({
		url,
		method: "GET",
		contentType,
		ref,
		fileName,
		skipSessionFailureOnAuthError,
		background,
	});
}

export async function postRequest<T>(url: URL, body: ApiPayload = {}, _token?: string): Promise<T> {
	return makeHttpRequest<T>({
		url,
		method: "POST",
		body,
	});
}

export async function putRequest<T>(url: URL, body: ApiPayload = {}, _token?: string): Promise<T> {
	return makeHttpRequest<T>({
		url,
		method: "PUT",
		body,
	});
}

export async function patchRequest<T>(url: URL, body: ApiPayload = {}): Promise<T> {
	return makeHttpRequest<T>({
		url,
		method: "PATCH",
		body,
	});
}

export async function deleteRequest<T>(url: URL, body: ApiPayload = {}, _token?: string): Promise<T> {
	return makeHttpRequest<T>({
		url,
		method: "DELETE",
		body,
	});
}
